import React, { Component, createRef } from "react";
import userAvatars from "./userAvatars.js";
import qrCtaImage from "./assets/qrcta.png";

export default class DashboardPreCampaign extends Component {
  constructor(props) {
    super(props);
    this.listRef = createRef();
    this.carouselRef = createRef();
    this.state = {
      isOverflowing: false,
    };
  }

  componentDidMount() {
    this.updateScrollDistance();
    window.addEventListener("resize", this.updateScrollDistance);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateScrollDistance);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.highscore !== this.props.highscore) {
      this.updateScrollDistance();
    }
  }

  updateScrollDistance = () => {
    if (this.listRef.current && this.carouselRef.current) {
      const listHeight = this.listRef.current.clientHeight;
      const carouselHeight = this.carouselRef.current.scrollHeight;
      const isOverflowing = carouselHeight > listHeight;
      const scrollDistance = carouselHeight - listHeight;

      this.carouselRef.current.style.setProperty(
        "--scroll-distance",
        `${-Math.max(scrollDistance, 0)}px`,
      );

      if (this.state.isOverflowing !== isOverflowing) {
        this.setState({ isOverflowing });
      }
    }
  };

  formatDate(unixTimestamp) {
    if (!unixTimestamp) return "-";
    const date = new Date(unixTimestamp * 1000);
    return date.toLocaleDateString("da-DK", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  }

  render() {
    const { campaign, company, highscore } = this.props;
    const users = highscore?.highscore || [];

    const minUsers = campaign?.minUsersOnTeam;
    const maxUsers = campaign?.maxUsersOnTeam;
    const hasTeamSizeLimits =
      (minUsers != null && minUsers != 0) ||
      (maxUsers != null && maxUsers != 0);

    let teamSizeText = "";
    if (minUsers && maxUsers) {
      teamSizeText = `(Hold skal have ${minUsers}-${maxUsers} medlemmer)`;
    } else if (minUsers) {
      teamSizeText = `(Hold skal have mindst ${minUsers} medlemmer)`;
    } else if (maxUsers) {
      teamSizeText = `(Hold kan have maks ${maxUsers} medlemmer)`;
    }

    return (
      <div
        className={`pre-campaign-container${
          users.length > 0 ? " has-users" : ""
        }`}
      >
        <div className="pre-campaign-top-row">
          <div className="pre-campaign-info">
            <h2 className="pre-campaign-title">Kom ind i Klimakampen</h2>
            <ol className="pre-campaign-steps">
              <li>
                Download appen via QR-koden til højre{" "}
                <span className="pre-campaign-arrow">&rarr;</span>
              </li>
              <li>
                Indtast adgangsnøglen{" "}
                <span className="pre-campaign-key">
                  {company?.companyKey || "-"}
                </span>
              </li>
              <li>
                Join et hold eller opret dit eget{" "}
                {hasTeamSizeLimits && (
                  <div className="pre-campaign-team-size">{teamSizeText}</div>
                )}
              </li>
              <li>Invitér dine kollegaer</li>
              <li>Spil med i {campaign?.weekAmount || 4} uger</li>
            </ol>
            <div className="pre-campaign-meta">
              <p className="pre-campaign-start">
                <strong>Starter:</strong>{" "}
                {this.formatDate(campaign?.nextLeagueStart)}
              </p>
              <p className="pre-campaign-link">
                Læs mere på{" "}
                <span className="pre-campaign-url">klimakampen.nu</span>
              </p>
            </div>
          </div>

          <div className="pre-campaign-right">
            <div className="pre-campaign-graphic">
              <img
                src={qrCtaImage}
                alt="QR-kode til download af appen"
                className="pre-campaign-graphic-image"
              />
            </div>
          </div>
        </div>

        {users.length > 0 && (
          <div className="pre-campaign-users">
            <h3 className="pre-campaign-users-title">
              Tilmeldte spillere ({users.length})
            </h3>
            <div className="pre-campaign-users-list" ref={this.listRef}>
              <div
                className={`pre-campaign-users-carousel ${
                  this.state.isOverflowing ? "" : "no-scroll"
                }`}
                ref={this.carouselRef}
              >
                {users.map((user, idx) => (
                <div key={idx} className="pre-campaign-user-item">
                  <div className="pre-campaign-user-avatar">
                    {user.avatarId && userAvatars[user.avatarId] ? (
                      <img
                        src={userAvatars[user.avatarId]}
                        alt={user.userName}
                        className="pre-campaign-avatar-img"
                      />
                    ) : (
                      <div className="pre-campaign-avatar-placeholder"></div>
                    )}
                  </div>
                  <span className="pre-campaign-user-name">
                    {user.userName}
                  </span>
                </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
